module.exports = __webpack_public_path__ + "static/media/no-internet.6c73dc9f.png";